import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faLaptopBinary } from '@fortawesome/pro-regular-svg-icons';

@Component({
  templateUrl: 'programmer-notes-dialog.component.html',
  styleUrls: ['programmer-notes-dialog.component.scss']
})
export class ProgrammerNotesDialogComponent implements OnInit {
  faLaptopBinary = faLaptopBinary;

  constructor(
    private dialogRef: MatDialogRef<ProgrammerNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { programmerNotes: string }
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('eiq-progNotes-dialog');
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
